import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import fr from '../img/flags/fr.svg'
import en from '../img/flags/en.svg'

const flags = {
  'fr': fr,
  'en': en
}

const SelectLanguage = (props) => {

  var selectedLang = null;
  var links = [];

  props.langs.forEach(function(lang) {
    if(lang.selected) {
      selectedLang = lang;
    } else {
      links.push(
        <Link className="navbar-item flag-link" to={lang.link} key={lang.langKey} hidden={lang.selected}>
          <figure className="image">
            <img src={flags[lang.langKey]} alt={lang.langKey} />
          </figure>
        </Link>
      );
    }
  });

  return (
    <div className="navbar-item has-dropdown is-hoverable">
      <Link className="navbar-item flag-link" to={selectedLang.link} key={selectedLang.langKey}>
        <figure className="image">
          <img src={flags[selectedLang.langKey]} alt={selectedLang.langKey} />
        </figure>
      </Link>
      <div className="navbar-dropdown">
        {links}
      </div>
    </div>
  );
};

SelectLanguage.propTypes = {
  langs: PropTypes.array
};

export default SelectLanguage;
